import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';

export default function FallBack() {
  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress style={{ color: 'rgb(0,0,0)' }} size={70} />
    </div>
  )
}
